/* eslint-disable react/destructuring-assignment */
// Copyright (c) 2016 Deere & Company

import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import React from 'react';

const NewTransferButtonGroup = (props) => (
    <section className="new-transfer-button-group">
        <button
            type="button"
            className="secondary"
            onClick={props.onResetClick}
        >
            <FormattedMessage id="RESET" />
        </button>
        <button
            type="button"
            className={props.transferClassName}
            disabled={props.disableTransfer}
            onClick={props.onCreateTransferClick}
        >
            <FormattedMessage id="TRANSFER" />
        </button>
    </section>
);
NewTransferButtonGroup.displayName = 'NewTransferButtonGroup';
NewTransferButtonGroup.propTypes = {
    disableTransfer: PropTypes.bool.isRequired,
    onCancelClick: PropTypes.func.isRequired,
    onCreateTransferClick: PropTypes.func.isRequired,
    onResetClick: PropTypes.func.isRequired,
    transferClassName: PropTypes.string.isRequired,
};

export default NewTransferButtonGroup;
